import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { Form, FormGroup, Label, Input, Row, Col, Button, Spinner } from 'reactstrap';
import './css/Formulario.css';
import { toPostRequest, getWeeksDiff } from './functions/ExpandTableFunctions';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import url from './variables/url.js';
const local = url.localBack;
const MySwal = withReactContent(Swal)

const ejSelect = [{ 'txt': 'Alola', 'id': 1 }, { 'txt': 'Fium', 'id': 3 }, { 'txt': 'Powder', 'id': 2 }]
const nivel = [{ 'txt': 'Grado', 'id': 1 }, { 'txt': 'Postgrado', 'id': 2 }, { 'txt': 'Admisiones', 'id': 3 }]

class FormularioMateriaVice extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            idForm: this.props.idForm ?? '0', fila: this.props.profesor.solicitudForm ?? {},
            next: false, profesor: this.props.profesor ?? null, idProf: this.props.idProf ?? '0',
            nombreProf: this.props.nombreProf ?? '', dataForm: this.props.dataForm ?? [],
            mensaje: '', viewDelegar: this.props.viewDelegar, infoDelegar: this.props.profesor.infoDelegado ?? null,
            horas: this.props.profesor.solicitudForm != null ? this.props.profesor.solicitudForm.horasTotal : this.props.profesor.totalHoras,
            roles: this.props.roles ?? [],
            infoDelegado: this.props.infoDelegado ?? false,
            banderaDecano: this.props.banderaDecano ?? false,
            messageUnidad: '', alertUnidad: true, messageNivel: '', alertNivel: true, messageTermino: '', alertTermino: true,
            FormEstado: [{ cod: 'N', nombre: '' }, { cod: 'L', nombre: 'Loading....' }],
            fileState: 'N',
            termino: this.props.profesor.strPeriodo.trim(),
            decanoRespuestas: this.props.decanoRespuestas
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        //console.log(this.state.fila);
        //console.log(this.props.profesor);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var dto = this.state.fila;
        let duracionTipo = 0;
        if (dto.nhorasSem > 0) {
            duracionTipo = dto.nhorasSem;
        } else {
            duracionTipo = this.state.profesor.duracionTipo;
        }
        dto[name] = value;
        if (name === "termino") {
            const nivel = this.state.profesor.strTipo === "M|R" ? "1" : this.state.profesor.strTipo === "M|P" ? "2" : "1";
            if (nivel === "1") {
                dto["fechaInicio"] = this.state.dataForm.terminos['grado'].find(x => x.idPeriodo === parseInt(value)).fechaInicio
                dto["fechaFin"] = this.state.dataForm.terminos['grado'].find(x => x.idPeriodo === parseInt(value)).fechaFin
                
            } else {
                dto["fechaInicio"] = this.state.dataForm.terminos['posgrado'].find(x => x.idPeriodo === parseInt(value)).fechaInicio
                dto["fechaFin"] = this.state.dataForm.terminos['posgrado'].find(x => x.idPeriodo === parseInt(value)).fechaFin
            }

        }
        else if ((name === "fechaInicio" || name === "fechaFin")) {
            let semanas = 0;
            if (name === "fechaInicio" && dto["fechaFin"] !== undefined) {
                semanas = getWeeksDiff(Date.parse(value), Date.parse(dto["fechaFin"]));
                let horas = semanas * duracionTipo;
                this.setState({ horas: horas });
            } else if (name === "fechaFin" && dto["fechaFin"] !== undefined) {
                semanas = getWeeksDiff(Date.parse(dto["fechaInicio"]), Date.parse(value));
                let horas = semanas * duracionTipo;
                this.setState({ horas: horas });
            }

        }

        this.setState({ fila: dto });
        //console.log(this.state.fila);

    }

    cleanForm = () => {
        /*console.log('entro a clean y limpio')*/
        let profesor = this.state.fila;
        profesor.fechaInicio = "";
        profesor.fechaFin = ""
        profesor.termino = "0"
        profesor.nivel = "0"
        profesor.idCargaUnidad = "0"
        this.setState({
            fila: profesor
        })
        /*console.log(this.state.fila)*/
    }

    mensajeUnidad(texto) {
        this.setState({ alertUnidad: false, messageUnidad: texto })
    }

    mensajeNivel(texto) {
        /*console.log(texto);*/
        this.setState({ alertNivel: false, messageNivel: texto })
    }

    mensajeTermino(texto) {
        /*console.log(texto);*/
        this.setState({ alertTermino: false, messageTermino: texto })
    }

    comprobar = () => {
        return this.state.fila.idCargaUnidad === "0" || this.state.fila.idCargaUnidad === undefined;
    }

    comprobarNivel = () => {
        return this.state.fila.nivel === "0" || this.state.fila.nivel === undefined;
    }

    comprobarTermino = () => {
        return this.state.fila.termino === "0" || this.state.fila.termino === undefined;
    }

    handleSave = (event) => {
        event.preventDefault();        
        let problemas = 0;
        const forma = new FormData(event.target);
        let dto = this.state.fila;
        /*console.log(forma)*/

        if (this.state.profesor["strAccion"] === "Eliminar Carga") {
            dto = toPostRequest(this.state.profesor);
            dto["observacion"] = forma.get("observacion")
            dto["totalHoras"] = 0
        } else {
            forma.forEach((value, clave) => {
                dto[clave] = value;
            })
            if (dto != null) {
                dto["idPersona"] = this.state.idProf;
                dto["idValidacionDet"] = this.state.idForm;
                /* dto["idAutoridad"]= this.state.idautoridad; */
            }
            
        }
        dto["aprobado"] = 1
        const data = JSON.stringify(dto);
        /*console.log(data);*/

        if(this.state.profesor.strAccion !== "Eliminar Carga"){
            if (this.comprobar()) {
                problemas++;
                this.mensajeUnidad('Por favor seleccione una unidad.')
            } else {
                this.setState({ alertUnidad: true });
            }

            if (this.comprobarNivel()) {
                problemas++;
                this.mensajeNivel('Por favor seleccione un nivel.')
            } else {
                this.setState({ alertTermino: true });
            }

            if (this.comprobarTermino()) {
                problemas++;
                this.mensajeTermino('Por favor seleccione un término.')
            } else {
                this.setState({ alertTermino: true });
            }
        }   

        /*console.log("PROBLEMAAAAAAAAAAS",problemas)*/

        if (problemas == 0) {
            this.setState({ fileState: 'L' });
            // to test
            // const val = {
            //     termino: this.state.multiTermino === '' ? this.state.terminos.join(' ') : this.state.multiTermino,
            //     horasTotal: parseInt(dto['totalHoras']), strObservacion: dto['observacion'], fechaFin: dto.fechaFin, fechaInicio: dto.fechaInicio,
            //     nivel: dto.nivel, idCargaUnidad: dto.idCargaUnidad
            // }
            // this.props.method(dto["idValidacionDet"], 'A', val)
            // const objUpdated = {}
            // MySwal.fire({
            //     icon: 'success',
            //     title: 'Solicitud ingresada',
            //     text: 'Datos guardados exitosamente!',
            //     confirmButtonText: 'Listo',
            //     timer: 5000
            // })

            fetch(local + 'Validacion/PostValidacion', {
           headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
           },
           method: 'POST',
           body: data,
        }).then((response) => {
           if (response.ok) {
               this.setState({ next: true });
               /*console.log('alola')*/
               this.setState({ fileState: 'N' });
               let val = this.state.fila;
               val['nivel'] = dto['nivel']
               val['horasTotal'] = dto['totalHoras']
               val['strObservacion'] = dto['observacion']
               this.props.method(dto["idValidacionDet"], 'A', val)
               MySwal.fire({
                   icon: 'success',
                   title: 'Solicitud ingresada',
                   text: 'Datos guardados exitosamente!',
                   confirmButtonText: 'Listo',
                   timer: 5000
               })
           } else {
               response.json().then(data => {
                   /*console.log(data);*/
                   this.setState({ fileState: 'N' });
                   MySwal.fire(
                       'Error',
                       data.lMensajesError[0],
                       'error'
                   )
               })

           }
        });
        }
        this.setState({ fileState: 'N' });
    }

    handleDecision = (estado) => {
        const idDet = this.state.infoDelegar.solicitudCoordinador.idValidDet
        const data = JSON.stringify({ idSolicitudDet: idDet, estado: estado })
        fetch(local + 'Delegacion/PostDecision', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: data,
        }).then((response) => {
            if (response.ok) {
                /*console.log('alola')*/
                MySwal.fire({
                    icon: 'success',
                    title: 'Solicitud ingresada',
                    text: 'Datos guardados exitosamente!',
                    confirmButtonText: 'Listo',
                    timer: 5000
                })
            } else {
                response.json().then(data => {
                    /*console.log(data);*/
                    MySwal.fire(
                        'Error',
                        data.lMensajesError[0],
                        'error'
                    )
                })

            }
        });
    }

    render() {
        const { infoDelegar, termino } = this.state;
        const nivel = this.state.profesor.strTipo === "M|R" ? "1" : this.state.profesor.strTipo === "M|P" ? "2" : "1";
        //console.log(this.state.profesor.strPeriodo);
        //console.log('Termino', termino);        
        let terminoCut = termino.replace('-',' ');
        //console.log('Termino-Cut', terminoCut);
        let idtermino = nivel === 1 ? this.state.dataForm.terminos['grado'].filter(x => x.nombre === termino || x.nombre === terminoCut).map(x => { return x.idPeriodo }) : this.state.dataForm.terminos['posgrado'].filter(x => x.nombre === termino || x.nombre === terminoCut).map(x => { return x.idPeriodo });
        //console.log(idtermino);

        let fechaInicioBeta = this.state.fila.fechaInicio != undefined ? this.state.fila.fechaInicio : nivel === 1 ? this.state.dataForm.terminos['grado'].find(x => x.nombre === termino || x.nombre === terminoCut).fechaInicio : this.state.dataForm.terminos['posgrado'].find(x => x.nombre === termino || x.nombre === terminoCut).fechaInicio;

        let fechaFinBeta = this.state.fila.fechaFin != undefined ? this.state.fila.fechaFin : nivel === 1 ? this.state.dataForm.terminos['grado'].find(x => x.nombre === termino || x.nombre === terminoCut).fechaFin : this.state.dataForm.terminos['posgrado'].find(x => x.nombre === termino || x.nombre === terminoCut).fechaFin;
        //console.log('fechaInicio', fechaInicioBeta);
        //console.log('fechaFin', fechaFinBeta);

        let inputTermino;

        /*let observacionDec = this.state.decanoRespuestas.filter(x => x.intIdValDetalle === this.state.idForm).map(x => { return x.observacion });*/

        let idCargaUnidad = this.state.profesor.unidadPlanifica != null ? this.state.dataForm.unidades.filter(x => x.nombreUnidad === this.state.profesor.unidadPlanifica).map(ex => ex.idUnidad) : 0;
              
        if (nivel === "1" || nivel === "2") {
            inputTermino = <Input
                id={"termino" + this.state.idForm}
                name="termino"
                type="select"
                className="mb-3"
                value={this.state.fila.termino}
                onChange={this.handleInputChange}
                readOnly={this.state.viewDelegar === "2"}
                disabled={this.props.banderaDecano}
            >
                <option key="0" value="0" >Elija el término académico </option>
                {nivel === "1" ?
                    this.state.dataForm.terminos['grado'].map(ej =>
                        <option key={ej.idPeriodo} selected={idtermino == ej.idPeriodo} value={ej.idPeriodo}>{ej.nombre}</option>
                    )
                    : this.state.dataForm.terminos['posgrado'].map(ej =>
                        <option key={ej.idPeriodo} selected={idtermino == ej.idPeriodo} value={ej.idPeriodo}>{ej.nombre}</option>
                    )
                }
            </Input>
        } else {
            inputTermino = <Input
                id={"termino" + this.state.idForm}
                name="termino"
                className="mb-3"
                readOnly
                defaultValue={"0"}
                value={"Elija el término académico"}
            >

            </Input>
        }
        return (
            <div>
                <Form id={'form' + this.state.idForm} onSubmit={this.handleSave}>
                    {(this.state.viewDelegar === "2" && infoDelegar.estadoCoordinador === "R") || this.state.profesor.strAccion === "Eliminar Carga" ?
                        <></>
                        :
                        <Row  >
                            <Col md={2}  >
                                <FormGroup >
                                    <Label for="anio" >
                                        Año
                                    </Label>
                                    <Input
                                        id={"anio" + this.state.idForm}
                                        name="anio"
                                        readOnly
                                        defaultValue={this.state.profesor.anio}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={2} >
                                <FormGroup >
                                    <Label for="totalHoras">
                                        Total horas
                                    </Label>
                                    {this.state.viewDelegar === "2" ?
                                        <Input
                                            id={"horas" + this.state.idForm}
                                            name="totalHoras"
                                            readOnly
                                            defaultValue={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.horasTotal
                                                : ''}
                                        />
                                        :
                                    <Input
                                        id={"horas" + this.state.idForm}
                                        name="totalHoras"
                                        readOnly
                                        defaultValue={this.state.profesor.totalHoras}
                                    />
                                            }
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="profesor">
                                        Profesor
                                    </Label>
                                    <Input
                                        id={"profesor" + this.state.idForm}
                                        name="profesor"
                                        readOnly
                                        defaultValue={this.state.nombreProf.split("/")[1]}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="nivel">
                                        Nivel
                                    </Label>
                                    <Input
                                        id={"nivel" + this.state.idForm}
                                        name="nivel"
                                        readOnly
                                        defaultValue={nivel === "1" ? "Grado" : nivel === "2" ? "Posgrado" : "Admisiones"}

                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    {(this.state.viewDelegar === "2" && infoDelegar.estadoCoordinador === "R") || this.state.profesor.strAccion === "Eliminar Carga" ?
                        <></>
                        :
                        <Row  >
                            <Col md={4}  >
                                <FormGroup >
                                    <Label for="idPlanificadoUnidad" >
                                        Planificado por Unidad
                                    </Label>
                                    <Input
                                        className="mb-3"
                                        type='textarea'
                                        name='idPlanificadoUnidad'
                                        id={'idPlanificadoUnidad' + this.state.idForm}
                                        readOnly
                                        defaultValue={this.state.profesor.unidadPlanifica}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="idCargaUnidad">
                                        Con cargo a la unidad
                                    </Label>
                                    {this.state.viewDelegar === "2" ? <Input
                                        className="mb-3"
                                        type='textarea'
                                        name='idCargaUnidad'
                                        id={'idCargaUnidad' + this.state.idForm}
                                        readOnly
                                        defaultValue={infoDelegar.solicitudCoordinador != null ? this.state.dataForm.unidades.find(
                                            x => x.idUnidad === parseInt(infoDelegar.solicitudCoordinador.idCargaUnidad)).nombreUnidad
                                            : ''}
                                    /> :
                                        <Input
                                            className="mb-3"
                                            name='idCargaUnidad'
                                            id={'idCargaUnidad' + this.state.idForm}
                                            type="select"
                                            value={this.state.fila.idCargaUnidad}
                                            onChange={this.handleInputChange}
                                            disabled={this.props.banderaDecano}
                                        >
                                            <option key="0" value="0" >Elija la unidad</option>
                                            {this.state.dataForm.unidades.map(ej =>
                                                <option key={ej.idUnidad} selected={idCargaUnidad == ej.idUnidad} value={ej.idUnidad}>{ej.nombreUnidad}</option>
                                            )}                                            
                                        </Input>}
                                    <Label hidden={this.state.alertUnidad} style={{ color: 'red' }}>
                                        *{this.state.messageUnidad}
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="termino">
                                        Periodo
                                    </Label>
                                    <br />
                                    {this.state.viewDelegar === "2" ? <Label>{infoDelegar.solicitudCoordinador != null ? nivel === "1" ?
                                        this.state.dataForm.terminos.grado.find(x => x.idPeriodo === parseInt(infoDelegar.solicitudCoordinador.termino)).nombre : 
                                        this.state.dataForm.terminos.posgrado.find(x => x.idPeriodo === parseInt(infoDelegar.solicitudCoordinador.termino)).nombre
                                         : ''}</Label> :
                                        inputTermino}
                                    <Label hidden={this.state.alertTermino} style={{ color: 'red' }}>
                                        *{this.state.messageTermino}
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    {(this.state.viewDelegar === "2" && infoDelegar.estadoCoordinador === "R") || this.state.profesor.strAccion === "Eliminar Carga" ?
                        <></>
                        :
                        <Row  >
                            <Col md={4}  >
                                <FormGroup >
                                    <Label for="actividad" >
                                        Actividad
                                    </Label>
                                    <Input
                                        type='textarea'
                                        className="mb-3"
                                        name='actividad'
                                        id={'actividad' + this.state.idForm}
                                        readOnly
                                        defaultValue={this.state.profesor.strTipo === 'M|R' ? "IMPARTICIÓN DE CLASES EN CURSOS DE GRADO" :
                                            this.state.profesor.strCategoria === 'C' ? "IMPARTICIÓN DE CLASES EN CURSOS DE POSGRADO INVESTIGACIÓN Y DOCTORADO" : this.state.profesor.strCategoria === 'P' ? "IMPARTICIÓN DE CLASES EN CURSOS DE POSGRADO PROFESIONALIZANTE" : "ERROR"}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4} >
                                <FormGroup >
                                    <Label for="descripcion">
                                        Asignatura
                                    </Label>
                                    <Input
                                        name='descripcion'
                                        type='textarea'
                                        id={'descripcion' + this.state.idForm}
                                        readOnly
                                        defaultValue={this.state.profesor.strDescripcion}
                                    >
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={2} >
                                <FormGroup >
                                    <Label for="fechaInicio">
                                        Fecha Ingreso
                                    </Label>
                                    {this.state.viewDelegar === "2" ?
                                        <Input
                                            id={"fechaInicio" + this.state.idForm}
                                            name="fechaInicio"
                                            type="date"
                                            value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.fechaInicio : ''}
                                            onChange={this.handleInputChange}
                                            style={{ padding: "0.375rem 0.375rem" }}
                                            readOnly
                                        />
                                        :
                                        <Input
                                            id={"fechaInicio" + this.state.idForm}
                                            name="fechaInicio"
                                            type="date"
                                            value={fechaInicioBeta}
                                            onChange={this.handleInputChange}
                                            style={{ padding: "0.375rem 0.375rem" }}
                                            disabled={this.props.banderaDecano}
                                            required
                                        />
                                    }

                                </FormGroup>
                            </Col>
                            <Col md={2} >
                                <FormGroup >
                                    <Label for="fechaFin">
                                        Fecha Fin
                                    </Label>
                                    {this.state.viewDelegar === "2" ?
                                        <Input
                                            id={"fechaFin" + this.state.idForm}
                                            name="fechaFin"
                                            type="date"
                                            value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.fechaFin : ''}
                                            style={{ padding: "0.375rem 0.375rem" }}
                                            readOnly
                                        />
                                        :
                                        <Input
                                            id={"fechaFin" + this.state.idForm}
                                            name="fechaFin"
                                            value={fechaFinBeta}
                                            type="date"
                                            onChange={this.handleInputChange}
                                            style={{ padding: "0.375rem 0.375rem" }}
                                            required
                                            disabled={this.props.banderaDecano}
                                        />}
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    {this.state.viewDelegar === "2" && (infoDelegar.estadoCoordinador === "R" || this.state.profesor.strAccion === "Eliminar Carga") ?
                        <></>
                        :
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="observacionProf">
                                        Observación
                                    </Label>
                                    <Input
                                        id={"observacionProf" + this.state.idForm}
                                        name="observacionProf"
                                        type="textarea"
                                        className='form-control'
                                        readOnly
                                        defaultValue={this.state.profesor.strObservacion}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label for="observacion">
                                    {this.state.roles.includes("COORDINADOR") ? "Recomendación del Subdecano" : this.state.viewDelegar === "2" ? "Recomendación del coordinador" : "Recomendación del Subdecano"}
                                </Label>
                                {this.state.viewDelegar === "2" ?
                                    <Input
                                        id={"observacion" + this.state.idForm}
                                        name="observacion"
                                        type="textarea"
                                        className='form-control'
                                        value={infoDelegar.solicitudCoordinador != null ? infoDelegar.solicitudCoordinador.strObservacion : ''}
                                        readOnly
                                    />
                                    :
                                    <Input
                                        id={"observacion" + this.state.idForm}
                                        name="observacion"
                                        type="textarea"
                                        className='form-control'
                                        onChange={this.handleInputChange}
                                        defaultValue={this.state.fila.strObservacion}
                                        readOnly={this.state.banderaDecano}
                                        maxLength="500"
                                        required
                                    />}
                            </FormGroup>
                        </Col>
                    </Row>
                    {/*<Row>*/}
                    {/*    <Col md={12}>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label for="observacion">*/}
                    {/*                Recomendación del Decano*/}
                    {/*            </Label>*/}
                    {/*            <Input*/}
                    {/*                id={"observacionDecano" + this.state.idForm}*/}
                    {/*                name={"observacionDecano-" + this.state.idForm}*/}
                    {/*                type="textarea"*/}
                    {/*                className='form-control'*/}
                    {/*                defaultValue={observacionDec != '' ? observacionDec : 'Ninguna Observación'}*/}
                    {/*                readOnly={true}*/}
                    {/*                required*/}
                    {/*            />*/}
                    {/*        </FormGroup>*/}
                    {/*    </Col>*/}
                    {/*</Row>                   */}

                </Form>

            </div>
        );
    }
}

export default FormularioMateriaVice;